'use client'

import { setupListeners } from "@reduxjs/toolkit/query";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { Provider } from "react-redux";
import { store } from '../model/store';

interface Props {
    readonly children: ReactNode;
}

export const StoreProvider = ({ children }: Props) => {

    useEffect(() => {
        // configure listeners using the provided defaults
        // optional, but required for `refetchOnFocus`/`refetchOnReconnect` behaviors
        return setupListeners(store.dispatch);
    }, []);

    return (
        <Provider store={store}>
            {children}
        </Provider>
    );
};

